import { render, staticRenderFns } from "./GoToComplexesButton.vue?vue&type=template&id=1682f21e"
import script from "./GoToComplexesButton.vue?vue&type=script&lang=js"
export * from "./GoToComplexesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports